import React, { useMemo } from 'react';
import DonutChartV2 from 'src/components/BeaconV2Components/DonutChart/DonutChartV2';
import DonutChartLoading from 'src/components/Charts/Donut/DonutChartLoading';
import { useMetricFormatter } from 'src/utils/Hooks';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { getVolumeStringParts } from 'src/utils/stringFormatting';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

export interface TotalTrafficDonutChartProps {
  totalClicks: number;
  organicClicks: number;
  paidTraffic: number;
  otherTraffic: number;
  dspClicks: number;
  loading: boolean;
}

/**
 * Displays the donut chart for total traffic with
 * each traffic type as a percentage
 */
const TotalTrafficDonutChart = ({
  dspClicks,
  loading,
  organicClicks,
  otherTraffic,
  paidTraffic,
  totalClicks
}: TotalTrafficDonutChartProps) => {
  const formatMetric = useMetricFormatter();

  const formattedTotalClicks = useMemo(() => {
    return `${formatMetric(totalClicks, METRICTYPE.VOLUME, { showFullValue: false, decimalPlaces: 2 })}`;
  }, [totalClicks, formatMetric]);

  return loading ? (
    <DonutChartLoading />
  ) : (
    <DonutChartV2
      getData={[
        {
          fieldId: 'organicClicks',
          name: 'Organic Traffic',
          y: organicClicks
        },
        {
          fieldId: 'paidTraffic',
          name: 'Paid Traffic',
          y: paidTraffic
        },
        {
          fieldId: 'otherTraffic',
          name: 'Other Traffic',
          y: otherTraffic
        },
        {
          fieldId: 'dspClicks',
          name: 'DSP Clicks',
          y: dspClicks
        }
      ]}
      title={
        <Flex flexDirection="column" gap="xs" alignItems="center">
          <Flex gap="sm" alignItems="center" justifyContent="center">
            <Text
              sx={{
                fontSize: '48px',
                fontWeight: 'bold'
              }}
            >
              {getVolumeStringParts(formattedTotalClicks).value}
            </Text>
            <Text variant="h4">{getVolumeStringParts(formattedTotalClicks).label}</Text>
          </Flex>
          <Text variant="h6">Total Traffic</Text>
        </Flex>
      }
    />
  );
};

export default TotalTrafficDonutChart;
